<script setup lang="ts">
import BaseLoader from '@/components/BaseComponents/BaseLoader.vue';
import CreditPackCard from '@/components/Plan/CreditPackCard.vue';
import { useFetch } from '@/composables/useFetch';
import { useEnvStore } from '@/stores/envStore';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

interface CreditPack {
  id: number;
  name: string;
  description: string;
  credits_amount: number;
  price: string;
  currency: string;
}

const { fetchData } = useFetch();
const envStore = useEnvStore();
const { t } = useI18n();

const creditPacks = ref<CreditPack[]>([]);
const loading = ref(true);
const isRedirecting = ref(false);

const fetchCreditPacks = async () => {
  loading.value = true;
  const { data } = await fetchData(`${envStore.apiUrl}/credit-packs`);
  if (data) {
    creditPacks.value = data;
  }
  loading.value = false;
};

onMounted(fetchCreditPacks);
</script>

<template>
  <div class="mx-auto max-w-4xl">
    <h2 class="mb-8 text-center font-bold text-2xl">{{ t('credits.purchaseTitle') }}</h2>
    <!-- <p class="mb-8 text-center text-gray-600">{{ t('credits.purchaseSubtitle') }}</p> -->

    <div v-if="loading" class="flex justify-center">
      <BaseLoader />
    </div>

    <div v-else-if="creditPacks.length" class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      <CreditPackCard
        v-for="pack in creditPacks"
        :key="pack.id"
        :pack="pack"
        :is-redirecting="isRedirecting"
        @update:is-redirecting="isRedirecting = $event"
      />
    </div>

    <div v-else class="text-center">
      <p>{{ t('credits.noPacksAvailable') }}</p>
    </div>
  </div>
</template>
